import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, commonData } from "@/mixins/index";
import addgatewayConfiguration from "./components/addgatewayConfiguration";
import parameterPopup from "@/components/parameterPopup/parameterPopup";
export default {
  name: "gatewayConfiguration",
  mixins: [loadMoreList, commonData],
  components: {
    addgatewayConfiguration: addgatewayConfiguration,
    parameterPopup: parameterPopup
  },
  data: function data() {
    return {
      pagingReqFn: "appGatewaySdkConfigData",
      delIds: [],
      paramsData: {
        isMustAppid: 2
      }
    };
  },
  activated: function activated() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.getcommonData(['appListAllData']);

              _this.getList();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    handleSelectionChange: function handleSelectionChange(e) {
      this.delIds = e;
    },
    reset: function reset(row, index, type) {
      var _this2 = this;

      this.$confirm('请确认当前操作?', '确认', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this2.$api.GatewaySdkresetJwt({
          id: row.id
        }).then(function (res) {
          if (res.status == 200) {
            _this2.$message.success('重置成功');

            _this2.tableData[index].jwt_secret = res.data;
          }
        });
      });
    },
    del: function del(dateList) {
      var _this3 = this;

      var ids = dateList.map(function (item) {
        return item.id;
      }).toString();
      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'appGatewaySdkConfigDel',
        data: {
          id: ids
        }
      }).then(function () {
        _this3.getList(_this3.paramsData.page);
      });
    }
  }
};